/** Price series + facts API calls. All public reads. */
import { apiFetch } from './apiClient';

const qs = (params = {}) => {
  const s = new URLSearchParams(
    Object.entries(params).filter(([, v]) => v != null && v !== '')
  ).toString();
  return s ? `?${s}` : '';
};

export const getFxSeries = (range = 'ALL', pair = 'NGN/USD') =>
  apiFetch(`/api/market/fx${qs({ range, pair })}`, { auth: false });
export const getFxLatest = (pair = 'NGN/USD') =>
  apiFetch(`/api/market/fx/latest${qs({ pair })}`, { auth: false });
export const getGlobalPrices = (range = 'ALL', commodityId) =>
  apiFetch(`/api/market/global-prices${qs({ range, commodityId })}`, { auth: false });
export const getSpeciesPrices = (range = 'ALL', speciesId) =>
  apiFetch(`/api/market/species-prices${qs({ range, speciesId })}`, { auth: false });
export const getLocalCommoditySeries = (range = 'ALL', commodityId) =>
  apiFetch(`/api/market/local-commodity-series${qs({ range, commodityId })}`, { auth: false });
/**
 * World Bank Pink Sheet monthly averages for one commodity, local or
 * exchange-traded.
 *
 * Called without a commodityId the endpoint returns only the mapping, which
 * commodities have a world reference at all. Nothing in the app uses that
 * form yet; the panel asks per commodity and renders nothing when the answer
 * is empty. It is there for a caller that needs to know up front.
 */
export const getWorldReference = (commodityId, months) =>
  apiFetch(`/api/market/world-reference${qs({ commodityId, months })}`, { auth: false });

/**
 * The same thing for several commodities at once, keyed by id.
 *
 * The benchmark carousel needs every card on one screen. Asking per card
 * would be a request each; the endpoint answers all of them from a single
 * windowed query.
 */
/**
 * The series catalogue: every World Bank series we keep, grouped for a
 * picker, plus which of our commodities maps to which. No prices, so it is
 * small and worth caching hard.
 */
export const getWorldSeriesCatalogue = () =>
  apiFetch('/api/market/world-reference', { auth: false });

export const getWorldReferenceBatch = (commodityIds, months) =>
  apiFetch(
    `/api/market/world-reference${qs({ commodityIds: (commodityIds || []).join(','), months })}`,
    { auth: false },
  );

export const getLocalPrices = (params) =>
  apiFetch(`/api/market/local-prices${qs(params)}`, { auth: false });
export const getPriceMovements = (state) =>
  apiFetch(`/api/market/price-movements${qs({ state })}`, { auth: false });
